import { AbstractEvent as r } from "./ghl-ui.es345.js";
class e extends r {
  get originalEvent() {
    return this.data.originalEvent;
  }
  get clientX() {
    return this.data.clientX;
  }
  get clientY() {
    return this.data.clientY;
  }
  get target() {
    return this.data.target;
  }
  get container() {
    return this.data.container;
  }
  get originalSource() {
    return this.data.originalSource;
  }
  get pressure() {
    return this.data.pressure;
  }
}
class a extends e {
}
a.type = "drag:start";
class s extends e {
}
s.type = "drag:move";
class n extends e {
}
n.type = "drag:stop";
class i extends e {
}
i.type = "drag:pressure";
export {
  s as DragMoveSensorEvent,
  i as DragPressureSensorEvent,
  a as DragStartSensorEvent,
  n as DragStopSensorEvent,
  e as SensorEvent
};
